import classNames from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';
import { update as updateQuiz } from '../../../ducks/quizLitmosReducer';

interface IProps {
  text?: string;
  showCollapsiblePanel: boolean;
  hasCollapsiblePanel: boolean;
}

export const ExplainerBar = ({ text, showCollapsiblePanel, hasCollapsiblePanel }: IProps) => {
  const dispatch = useDispatch();
  return (
    <div className="ExplainerBar-wrapper">
      <div className={classNames('ExplainerBar', { 'has-collapsible-panel': hasCollapsiblePanel })}>
        {hasCollapsiblePanel && (
          <span
            className={classNames('ExplainerBar-button material-icons', {
              expanded: showCollapsiblePanel,
            })}
            onClick={() => {
              dispatch(
                updateQuiz({
                  showCollapsiblePanel: !showCollapsiblePanel,
                }),
              );
            }}
          >
            chevron_right
          </span>
        )}
        <div className="ExplainerBar-text">{text}</div>
      </div>
    </div>
  );
};
